/**
 * Vínculo com Perfil de Usuário do Portal.
 *
 * Ao contrário do restante do Cadastro de Funcionários, o Perfil já existe de verdade no backend
 * (ver back_gestorprojeto/.../administracao/gerenciamento/Perfil/PerfilController.js e o model
 * Perfil.js) — por isso essas funções chamam a API real, no mesmo padrão usado por
 * `Administracao/Gerenciamento/Perfis/index.js`, e não fazem parte do mock de Funcionário.
 */

import api from '~/services/api';

export async function findAllPerfis() {
  return api.get('/signed/empresa/administracao/gerenciamento/perfis');
}

export async function findPerfilById(id) {
  return api.get('/signed/empresa/administracao/gerenciamento/perfil', { params: { id } });
}

export default { findAllPerfis, findPerfilById };
